/**
 * Which Paige this tab runs and which is deployed now (docs/engineering/web.md, "When Paige is
 * updated"). A build writes the same version into index.html's `<meta name="paige-version">` and
 * into `/version.json` (apps/web/vite.version.ts); the page's own meta is this bundle's version,
 * because index.html is what named the bundle the tab loaded.
 */

/** Where the deployed version is asked; nginx and `vite preview` serve it `no-store`. */
export const versionUrl = '/version.json';

/** This tab's version, or null when the page has none (the dev server; nothing to compare). */
export function ownVersion(doc: Document = document): string | null {
  const content = doc.querySelector('meta[name="paige-version"]')?.getAttribute('content');
  return content ? content : null;
}

/**
 * The deployed version, or null when it cannot be told (offline, a refusal, a body that is not the
 * file): an unanswered check is never read as "updated", so a hiccup never reloads anybody.
 */
export async function fetchDeployedVersion(
  fetchImpl: typeof fetch = (input, init) => fetch(input, init),
): Promise<string | null> {
  try {
    const response = await fetchImpl(versionUrl, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    const body = (await response.json()) as { version?: unknown };
    return typeof body.version === 'string' && body.version ? body.version : null;
  } catch {
    return null;
  }
}
